<script>
import Utils from '@/services/utils.js'

export default {
  name: "UiSwitch",
  props: {
    value: {
      type: [Boolean, Number, String],
      required: true,
    },
    trueValue: {
      type: [Boolean, Number, String],
      default: true
    },
    falseValue: {
      type: [Boolean, Number, String],
      default: false
    },
    labelYes: {
      type: String,
      default: () => Utils.t('global.yes')
    },
    labelNo: {
      type: String,
      default: () => Utils.t('global.no')
    },
  },
  data() {
    return {
      isChecked: this.value === this.trueValue
    }
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue ? this.trueValue : this.falseValue);
    }
  },
  watch: {
    value(newVal) {
      this.isChecked = newVal;
    }
  },
};
</script>
<template>
  <div class="UiSwitch">
    <input type="checkbox" :checked="isChecked" @change="updateValue($event.target.checked)"/>
    <span class="option yes" :class="isChecked && 'is-active'">{{ labelYes }}</span>
    <span class="option no" :class="!isChecked && 'is-active'">{{ labelNo }}</span>
    <div class="focus-helper"></div>
  </div>
</template>

<style lang="scss" scoped>
.UiSwitch {
  background-color: var(--input-bg);
  border: var(--input-border);
  border-radius: var(--input-radius);
  position: relative;
  cursor: pointer;
  min-height: var(--input-height);
  display: flex;
  justify-content: stretch;
  padding: 3px;

  input[type=checkbox] {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    inset: -1px;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    margin: 0;
    appearance: none;
    -webkit-appearance: none;

    .focus-helper {
      pointer-events: none;
    }

    &:focus-visible ~ .focus-helper {
      box-shadow: 0 0 0 2px var(--colors-focus);
      position: absolute;
      inset: 0;
      border-radius: inherit;
    }
  }

  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.1;
    text-align: center;
    transition-property: background-color, color;
    width: 50%;
    flex: 1;
    padding-block: 4px;
    border-radius: var(--radius-base);
    color: var(--colors-gray-400);
  }
  .option.is-active {
    background-color: var(--accent-color);
    color: var(--accent-color-contrast);
  }
}
</style>
